// extracted by mini-css-extract-plugin
export var defaultAvatar = "ProfileAvatar-module--defaultAvatar--3673b";
export var lmsScrollbar = "ProfileAvatar-module--lms-scrollbar--9a967";